import { useTranslation } from 'react-i18next'

import { VideoPlatform } from '../constants'
import composeVideoPlatformPattern from '../helpers/videoValidationPattern/composeVideoPlatformPattern'
import enabledVideoPlatforms from '../helpers/videoValidationPattern/enabledVideoPlatforms'
import videoPlatformDisplayName from '../videoPlatformDisplayName'

type Options = {
    disabledPlatforms?: VideoPlatform[]
}

export function useInsertVideo({ disabledPlatforms = [] }: Options = {}) {
    const { t } = useTranslation()

    const {
        kalturaVideoEnabled,
        kalturaVideoPartnerId,
        kalturaVideoPlayerId,
        blueBillywigVideoEnabled,
        blueBillywigPlayoutId,
        blueBillywigPartnerId,
    } = window.__SETTINGS__

    const videoPlatforms = enabledVideoPlatforms({
        kaltura: {
            enabled: kalturaVideoEnabled,
            partnerId: kalturaVideoPartnerId,
            playerId: kalturaVideoPlayerId,
        },
        blueBillywig: {
            enabled: blueBillywigVideoEnabled,
            playoutId: blueBillywigPlayoutId,
            partnerId: blueBillywigPartnerId,
        },
    }).filter((platform) => !disabledPlatforms.includes(platform))

    const videoValidationPattern = composeVideoPlatformPattern({
        enabledPlatforms: videoPlatforms,
    })

    const videoHelper = t('action.insert-video-helper', {
        platforms: videoPlatforms
            .map((platform) => videoPlatformDisplayName(platform))
            .join(', '),
    })

    return {
        videoValidationPattern,
        videoHelper,
    }
}

export default useInsertVideo
